import React from 'react'
import LineTagAltIcon from 'components/Luxkit/Icons/line/LineTagAltIcon'
import LineGlobeAltIcon from 'components/Luxkit/Icons/line/LineGlobeAltIcon'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import { TFunction } from 'i18next'
import LineGiftIcon from 'components/Luxkit/Icons/line/LineGiftIcon'

export type WhyBookWithUsTileContent = {
  Icon: JSX.Element;
  heading: string;
  body: string;
}

export const uspContent = (t: TFunction<'uspComponent'>, regionCodeContext: string): WhyBookWithUsTileContent[] => {
  const options = { ns: 'uspComponent', context: regionCodeContext }
  return [
    {
      Icon: <LineTagAltIcon size="S" />,
      heading: t('saveTitle', options),
      body: t('saveText', options),
    },
    {
      Icon: <LineGiftIcon size="S" />,
      heading: t('bonusTitle', options),
      body: t('bonusText', options),
    },
    {
      Icon: <LineGlobeAltIcon size="S" />,
      heading: t('oneStopTitle', options),
      body: t('oneStopText', options),
    },
    {
      Icon: <LineClockDollarIcon size="S" />,
      heading: t('flexibleTitle', options),
      body: t('flexibleText', options),
    },
    {
      Icon: <LinePhoneIcon size="S" />,
      heading: t('24hrServiceTitle', options),
      body: t('24hrServiceText', options),
    },
  ]
}
